import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Route, Link } from "react-router-dom";
import { Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem, NavLink, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import { arrayHelper } from "../../../../helpers/arrayHelper";
import Media from "react-media";
import "./MenuLayout.css";
import PageViewLayout from "../../page/container/View/Layout/PageViewLayout";
import PostFormLayout from "../../form/containers/PostFormLayout/PostFormLayout";
import { getKey } from "../../../../helpers/UrlHelper";

export class MenuLayout extends React.Component {
  state = {
    isOpen: false,
    collapsed: true,
  };
  componentDidMount() {
    const { template, headerHeight } = this.props;
    if (template.content.menu.position === "fixed" && headerHeight !== undefined)
      window.onscroll = function () {
        this.fixateMenuToTop(headerHeight.clientHeight);
      };
  }
  componentDidUpdate(prevProps) {
    if (this.props.headerHeight !== undefined && prevProps.headerHeight !== this.props.headerHeight && this.props.template.content.menu.position === "fixed") {
      const { template, headerHeight } = this.props;
      window.onscroll = () => this.fixateMenuToTop(headerHeight.clientHeight);
    }
  }
  componentWillUnmount() {
    const { template, headerHeight } = this.props;
    if (template.content.menu.position === "fixed" && headerHeight !== undefined) window.onscroll = null;
  }
  replaceUrlTags = (url) => {
    const { attendee } = this.props;
    let path = url.toString();
    let badgeNo = "";
    let lang = ""
    let hasOrder = attendee && attendee.orders && attendee.orders.length > 0 && this.props.attendee.orders[0].orderId !== undefined;
    if (window.location && window.location.search) {
      const paramProps = new URLSearchParams(window.location.search);
      if (paramProps.get(getKey("badgeno", paramProps))) badgeNo = paramProps.get(getKey("badgeno", paramProps));
      else if (paramProps.get(getKey("clientkey", paramProps))) badgeNo = paramProps.get(getKey("clientkey", paramProps));

      if (paramProps.get(getKey("lang", paramProps))) lang = paramProps.get(getKey("lang", paramProps));
    }
    if (/\[BadgeNo\]/gi.test(path)) {
      if (hasOrder && badgeNo) {
        path = path.replace(/\[BadgeNo\]/gi, badgeNo);
      } else {
        path = path.replace(/&*badgeno=\[BadgeNo\]/gi, "");
        path = path.replace(/&*clientkey=\[BadgeNo\]/gi, "");
      }
    }
    if (/\[ClientKey\]/gi.test(path)) {
      if (hasOrder && badgeNo) {
        path = path.replace(/\[ClientKey\]/gi, badgeNo);
      } else {
        path = path.replace(/&*badgeno=\[ClientKey\]/gi, "");
        path = path.replace(/&*clientkey=\[ClientKey\]/gi, "");
      }
    }

    if(/lang=.{3}/gi.test(path) && lang){
      path = path.replace(/lang=.{3}/gi, "lang="+lang);
    }
    else if(lang){
      path = path + "&lang="+lang;
    }

    return path;
  };
  // appendBadgeNo = (url) => {
  //   const { attendee } = this.props;

  //   if (window.location && window.location.search) {
  //     /*  let params = "/?"; */
  //     const paramProps = new URLSearchParams(window.location.search);

  //     let hasOrder = attendee && attendee.orders && attendee.orders.length > 0 && this.props.attendee.orders[0].orderId !== undefined;

  //     let lang = "";
  //     let badgeNo = "";

  //     if (paramProps.get(getKey("badgeno", paramProps))) {
  //       badgeNo = paramProps.get(getKey("badgeno", paramProps));
  //     } else if (paramProps.get(getKey("clientkey", paramProps)) && hasOrder) badgeNo = paramProps.get(getKey("clientkey", paramProps));

  //     lang = paramProps.get(getKey("languagecode", paramProps));
  //     if (!lang) lang = paramProps.get(getKey("lang", paramProps));

  //     let searchParam = "";
  //     if (!url.includes("lang")) {
  //       searchParam =
  //         "?" +
  //         new URLSearchParams({
  //           lang: lang || "swe",
  //         }).toString();
  //     }

  //     if (badgeNo && !url.includes("badgeNo")) {
  //       searchParam =
  //         "?" +
  //         new URLSearchParams({
  //           lang: lang || "swe",
  //           badgeNo,
  //         }).toString();
  //     }
  //     /* 
  //       paramProps.forEach(function (value, key) {
  //         params += `${key}=${value}&`;
  //       });
  //       if (params.charAt(params.length - 1) === "&")
  //         params = params.slice(0, params.length - 1); */

  //     return url + searchParam;
  //   }
  //   /* } */
  //   return url;
  // };
  fixateMenuToTop = (headerHeight = 0) => {
    const { template } = this.props;
    if (document.body.scrollTop > headerHeight || document.documentElement.scrollTop > headerHeight) {
      const el = document.body;
      let isOverflowing = el.clientWidth < el.scrollWidth || el.clientHeight < el.scrollHeight;

      if (isOverflowing) {
        try {
          document.getElementById("menu-bar-mobile").classList.add("fixed-top");
          document.getElementById("menu-bar").classList.add("fixed-top");
          document.getElementById("menu-bar").style.width = template.content.header.width;
        } catch (error) {}
      }
    } else {
      try {
        document.getElementById("menu-bar-mobile").classList.remove("fixed-top");
        document.getElementById("menu-bar-mobile").style.width = "100%";
        document.getElementById("menu-bar").classList.remove("fixed-top");
        document.getElementById("menu-bar").style.width = template.content.menu.innerWidth;
      } catch (error) {}
    }
  };
  getMenuList = () => {
    const { menu, cms } = this.props;
    if (!Array.isArray(menu) || menu.length === 0) return undefined;
    const newMenuItems = Array.from(menu);
    newMenuItems.map((mi, i) => {
      if (
        /*  mi.appendBadgeNo === true &&
        !mi.url.includes("/?badgeNo=") && */
        cms.editMode == false
      ) {
        mi.url = this.replaceUrlTags(mi.url);
      }
    });
    return newMenuItems;
  };
  alignMenuItems = (value) => {
    switch (value) {
      case "center":
        return "align-center";
      case "left":
        return "mr-auto";
      case "right":
        return "ml-auto";
      default:
        break;
    }
  };
  render() {
    const { isOpen, collapsed } = this.state;
    const { template, menu, headerHeight, cms } = this.props;
    const navBrand =
      menu !== undefined && menu
        ? menu.find((mi) => {
            return mi.sortOrder === 0;
          })
        : null;
    const itemAlignment = this.alignMenuItems(template.content.menu.justifyContent);
    if (template.content.menu.display === "none" || template.content.menu.display === "unset") return null;
    const menuItems = this.getMenuList();
    return (
      <div className="responsive-header ">
        <Media
          queries={{
            mobile: "(max-width: 769px)",
            desktop: "(min-width: 770px)",
          }}
        >
          {(matches) => (
            <React.Fragment>
              {matches.desktop ? (
                <div
                  className="responsive-header"
                  style={{
                    backgroundColor: template.content.menu.backgroundColor,
                    display: "inline-flex",
                    width: "100%",
                    marginLeft: "auto",
                    marginRight: "auto",
                  }}
                >
                  <Navbar
                    id="menu-bar"
                    style={{
                      backgroundColor: template.content.menu.backgroundColor,
                      padding: template.content.menu.padding,
                      /*      maxHeight: '50px', */
                      height: "auto",
                      marginLeft: "auto",
                      marginRight: "auto",
                      width: template.content.menu.innerWidth,
                      /*           display: menu.length > 6 ? 'none' : undefined */
                    }}
                    expand="md"
                  >
                    {navBrand ? <NavbarBrand href="/">{navBrand.label}</NavbarBrand> : null}
                    <NavbarToggler onClick={() => this.setState({ isOpen: !this.state.isOpen })} />
                    <Collapse isOpen={isOpen} navbar>
                      <Nav className={itemAlignment} style={{ flexWrap: "wrap" }} navbar>
                        {menuItems !== undefined ? DrawMenuList(menuItems, { ...template.content.menu }, false, cms.editMode) : null}
                      </Nav>
                    </Collapse>
                  </Navbar>
                </div>
              ) : null}
              {matches.mobile ? (
                <div style={{ width: "100%" }} className="responsive-header">
                  <Navbar
                    id="menu-bar-mobile"
                    className="nav-hamburger"
                    color="faded"
                    light
                    style={{
                      backgroundColor: template.content.menu.backgroundColor,
                      minHeight: "50px",
                      height: "auto",
                      width: template.content.menu.innerWidth,
                      /*     display: menu.length > 6 ? 'inline-flex' : undefined */
                    }}
                  >
                    <NavbarToggler
                      style={{
                        color: template.content.menu.color,
                        padding: 10,
                        border: "none",
                        fontSize: template.content.menu.fontSize,
                      }}
                      onClick={() => this.setState({ collapsed: !this.state.collapsed })}
                      className="mr-2"
                    >
                      <i className="fa fa-bars" />
                    </NavbarToggler>
                    <Collapse
                      style={{
                        backgroundColor: template.content.menu.backgroundColor,
                      }}
                      className="customized-falldown"
                      isOpen={!collapsed}
                      navbar
                    >
                      <Nav navbar>{menuItems !== undefined ? DrawMenuList(menuItems, { ...template.content.menu }, true, cms.editMode) : null}</Nav>
                    </Collapse>
                  </Navbar>
                </div>
              ) : null}
            </React.Fragment>
          )}
        </Media>
      </div>
    );
  }
}

function DrawMenuList(menuItems, template, isHamburger, editMode) {
  const { fontFamily, backgroundColor, fontSize, fontWeight, color } = template;

  return (
    <React.Fragment>
      {arrayHelper
        .sortByParam(menuItems, "sortOrder")
        .filter((mi) => {
          return mi.parentMenuId === null;
        })
        .map((mi, i) => {
          if (
            menuItems.find((mc) => {
              return mc.parentMenuId === mi.menuId;
            })
          ) {
            return (
              <UncontrolledDropdown className={`${isHamburger ? "falldown-item" : ""}`} nav inNavbar={!isHamburger}>
                <DropdownToggle
                  style={{
                    fontFamily: fontFamily,
                    fontSize: fontSize,
                    fontWeight: fontWeight,
                    color: `${color}`,
                  }}
                  nav
                  caret
                >
                  {mi.label}
                </DropdownToggle>
                <DropdownMenu style={{ backgroundColor: backgroundColor, border: 0 }} right>
                  {arrayHelper
                    .sortByParam(menuItems, "sortOrder")
                    .filter((mii) => {
                      return mii.parentMenuId == mi.menuId;
                    })
                    .map((mii, ii) => {
                      return (
                        <DropdownItem className="falldown-item" key={ii}>
                          {/*   {mc.target}
                      {mc.target} */}
                          <NavLink
                            disabled={editMode}
                            style={{
                              fontFamily: fontFamily,
                              fontSize: fontSize,
                              fontWeight: fontWeight,
                              color: `${color}`,
                            }}
                            target={mii.target ? `${mii.target}` : "_self"}
                            href={
                              window.location.toString().includes("localhost") && !mii.url.includes("localhost") && mii.url.includes("jirango.com/cms")
                                ? mii.url.replace("jirango.com/cms", "localhost:44375")
                                : mii.url
                            }
                          >
                            {mii.label}
                          </NavLink>
                        </DropdownItem>
                      );
                    })}
                </DropdownMenu>
              </UncontrolledDropdown>
            );
          } else {
            return (
              <NavItem key={i} className={`${isHamburger ? "falldown-item" : ""}`} style={window.location.pathname === mi.url ? { backgroundColor: template["&:active"].backgroundColor } : undefined}>
                {/*     {mi.url.includes('/p') ? <Link to='/cms/form/65' >{mi.label}</Link>: */}
                <NavLink
                  disabled={editMode}
                  target={mi.target ? `${mi.target}` : "_self"}
                  style={{
                    fontFamily: fontFamily,
                    fontSize: fontSize,
                    fontWeight: fontWeight,
                    color: window.location.pathname === mi.url ? template["&:active"].color : `${color}`,
                  }}
                  href={
                    window.location.toString().includes("localhost") && !mi.url.includes("localhost") && mi.url.includes("jirango.com/cms")
                      ? mi.url.replace("jirango.com/cms", "localhost:44375")
                      : mi.url
                  }
                >
                  {mi.label}
                </NavLink>

                {/*  } */}
              </NavItem>
            );
          }
        })}
    </React.Fragment>
  );
}

function mapStateToProps(state) {
  return {
    cms: state.cms,
    template: state.template.template,
    menu: state.template.menu,
    menuItems: state.menu,
    attendee: state.attendee,
  };
}

export default connect(mapStateToProps)(MenuLayout);
